import React, { useState, useEffect } from "react";
import { getAccountDisabledPageConfig } from "../API/config";

function AccountDisabledPage() {
	const [pageTile, setPageTile] = useState(null);
	const [pageBody, setPageBody] = useState(null);
	const defaultMessages = [
		{ Value: "<p>It appears that your account is disabled.</p>" },
		{ Value: "<p>If you believe this is an error, please contact your system administrator. Be sure to include your name, email address and a brief description of the issue.</p>" }
	];

	useEffect(() => {
		fetchConfig();
	}, []);

	const fetchConfig = async () => {
		await getAccountDisabledPageConfig()
			.then((responseJson) => {
				const config = JSON.parse(responseJson);
				setTitle(config?.AccountDisabled?.Info?.Title?.Value);				
				setBody(config?.AccountDisabled?.Info?.Body);
			})
			.catch((error) => {
				setTitle(null);
				setBody(null);
				console.error(error);
			});
	}

	function setTitle(configTitle){
		setPageTile(configTitle || "<h4 className=\"h5 alert-heading\">Account Disabled</h4>" );
	}
	function setBody(configBodyMessages){
		let messageElemets = '';
		var messages =  configBodyMessages || defaultMessages;

		messages.forEach(element => {
			messageElemets += element.Value;
		});
		setPageBody(messageElemets);
	}

	return (
		<div className="container-xl">
			<div className="row justify-content-center">
				<div className="col-12 col-sm-10 col-md-6">
					<div className="alert alert-info mt-8" role="alert">
						<div className="alert-icon"></div>
						<div className="alert-content">
							<h4 className="h5 alert-heading" dangerouslySetInnerHTML={{ __html: pageTile }}></h4>
							<p dangerouslySetInnerHTML={{ __html: pageBody }}></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AccountDisabledPage